import { TextField, TextFieldProps } from '@mui/material';
import { FC } from 'react';
import borders from 'style/border-vars.module.scss';

const InputBox: FC<TextFieldProps> = ({ ...props }) => {
  return (
    <TextField
      fullWidth
      margin="normal"
      variant="outlined"
      sx={{
        '& .MuiOutlinedInput-notchedOutline': {
          border: props.value === '' ? borders.lightBlue : borders.normalBlack,
        },
      }}
      {...props}
    />
  );
};

export default InputBox;
